import type { IIdeaWait } from '@featit/shared';

/** An idea's wait as the reader reads it: who may press "Ask now", where the line offers it. */
export type IdeaWaitViewType = IIdeaWait & { askNowRefusal?: string | null };
import { gql } from './GraphqlClient';

/** One idea the reader reported, with its wait (F-0461, OF-31). */
export interface IMyIdea {
  id: string;
  key: string;
  title: string;
  workAreaId: string;
  workAreaName: string;
  workAreaSlug: string;
  namespace: string | null;
  statusName: string;
  createdAt: string;
  wait: IdeaWaitViewType;
}

/** F-0461: "My ideas" — the same query the SDK's `myIdeas` sends. */
class MyIdeasApiService {
  async list(): Promise<IMyIdea[]> {
    const data = await gql<{ myIdeas: IMyIdea[] }>(
      `query MyIdeas {
        myIdeas {
          id key title workAreaId workAreaName workAreaSlug namespace statusName createdAt
          wait { state since expectedBy endedAt line twiceLateFrom askNow askedAt askedName askNowRefusal }
        }
      }`,
    );
    return data.myIdeas;
  }

  /** OF-83: the owner's "Ask now" — one question to one person; answers the line as it now reads. */
  async askNow(ideaId: string): Promise<IdeaWaitViewType> {
    const data = await gql<{ askNowOnIdea: IdeaWaitViewType }>(
      `mutation AskNowOnIdea($ideaId: ID!) {
        askNowOnIdea(ideaId: $ideaId) {
          state since expectedBy endedAt line twiceLateFrom askNow askedAt askedName askNowRefusal
        }
      }`,
      { ideaId },
    );
    return data.askNowOnIdea;
  }
}

export const myIdeasApi = new MyIdeasApiService();
